"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadSubappDrPicaso = exports.loadCCSubapp = exports.loadWebSubapp = exports.loadAsisSubapp = exports.loadSubapp = void 0;
const contactCenter_1 = require("../../contactCenter");
const features_1 = require("../../features");
const subapp_renderizers_1 = require("./subapp.renderizers");
const loadSubapp = async (config, Subapp, setFramework) => {
    if ((0, features_1.isWebViewPlatform)()) {
        (0, subapp_renderizers_1.initializeHybridSubapp)(config, Subapp, setFramework);
    }
    else if ((0, contactCenter_1.isContactCenter)()) {
        (0, subapp_renderizers_1.initializeCCSubapp)(config, Subapp, setFramework);
    }
    else {
        (0, subapp_renderizers_1.initializeWebSubapp)(config, Subapp, setFramework);
    }
};
exports.loadSubapp = loadSubapp;
const loadAsisSubapp = async (config, Subapp, setFramework) => {
    (0, subapp_renderizers_1.initializeAsisSubapp)(config, Subapp, setFramework);
};
exports.loadAsisSubapp = loadAsisSubapp;
const loadWebSubapp = async (config, Subapp, setFramework) => {
    (0, subapp_renderizers_1.initializeWebSubapp)(config, Subapp, setFramework);
};
exports.loadWebSubapp = loadWebSubapp;
const loadCCSubapp = async (config, Subapp, setFramework) => {
    (0, subapp_renderizers_1.initializeCCSubapp)(config, Subapp, setFramework);
};
exports.loadCCSubapp = loadCCSubapp;
const loadSubappDrPicaso = async (config, Subapp, setFramework) => {
    (0, subapp_renderizers_1.initializeDrPicasoSubapp)(config, Subapp, setFramework);
};
exports.loadSubappDrPicaso = loadSubappDrPicaso;
//# sourceMappingURL=subapp.loaders.js.map